import keyMirror from 'keymirror';

export type DeviceStatus = 'online' | 'offline' | 'unhealthy';

/**
 * Represents the status information of a device at a specific point in time.
 */
export type DeviceStatusInfo = {
  /**  The current status of the device. */
  status: DeviceStatus;
  /**  The Unix timestamp (in milliseconds) when the status was recorded. */
  timestamp: number;
  /**  An object mapping the source of the status(e.g. component name) to a descriptive reason. */
  reason?: { [source: string]: string };
};

/**
 * Represents information about the latest deployment.
 */
export type DeploymentInfo = {
  /** The current status of the deployment. */
  status: 'FAILED' | 'SUCCEEDED' | 'COMPLETED' | 'REJECTED' | 'CANCELED';
  /**  The Unix timestamp (in milliseconds) when the deployment occurred. */
  timestamp?: number;
  /** Failure reason in case the deployment failed. */
  reason?: string;
};

export const ActionTypes = keyMirror({
  SET_ASSETS: null
});

export interface IAssetsState {
  assets: IEdgeDevice[]
}


export interface IEdgeDevice {
  companyId: string,
  siteId: string,
  iotThingName: string,
  mac: string,
  statusInfo?: DeviceStatusInfo;
  lastDeploymentInfo?: DeploymentInfo;
  componentVersions?: { [componentName: string]: string };
}
